import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  createBusinessDetails,
  getAllBusinessDetails,
  getBusinessDetails,
  updateBusinessDetails,
} from "../../services/auth.service";
import { useSelector } from "react-redux";
import Select from "react-select";

export default function Setup() {
  const [isLoading2, setIsLoading2] = useState(false);
  const { token } = useSelector((state) => state?.auth);
  const [businessDetails, setBusinessDetails] = useState(null);
  const [businessId, setBusinessId] = useState(null);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[Z]{1}[0-9A]{1}$/;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    clearErrors,
  } = useForm();

  const fetchBusinessDetails = async () => {
    try {
      const res = await getBusinessDetails(token, businessId);

      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);

        setBusinessDetails(res?.data);
      } else {
        console.error("Error fetching business details:", res);
      }
    } catch (error) {
      console.error("Error fetching business details:", error);
    }
  };

  const fetchAllBusinessDetails = async () => {
    try {
      const res = await getAllBusinessDetails(token);

      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);

        const smallestIdEntry = res.data.reduce((min, current) =>
          current.id < min.id ? current : min
        );

        // console.log(smallestIdEntry);

        setBusinessId(smallestIdEntry?.id);
      } else {
        console.error("Error fetching all business details:", res);
      }
    } catch (error) {
      console.error("Error fetching all business details:", error);
    }
  };

  useEffect(() => {
    if (businessId) {
      fetchBusinessDetails();
    }
  }, [businessId]);

  useEffect(() => {
    fetchAllBusinessDetails();
  }, []);

  useEffect(() => {
    if (businessDetails && typeof businessDetails === "object") {
      Object.keys(businessDetails).forEach((key) =>
        setValue(key, businessDetails[key])
      );
    }
  }, [businessDetails, setValue]);

  // const getErrorMessage = (res) => {
  //   if (res?.data) {
  //     return (
  //       Object.values(res.data)
  //         .flat()
  //         .join("<br/>") ||
  //       "Invalid input. Please check your data."
  //     );
  //   }
  //   return "An unexpected error occurred. Please try again later.";
  // };

  const getErrorMessage = (res) => {
    if (res?.data) {
      // Map errors to distinct messages
      const errors = Object.entries(res.data).flatMap(([key, messages]) => {
        if (Array.isArray(messages)) {
          return messages.map((msg) => {
            if (key === "email") {
              return `Error in Email: ${msg}`;
            } else if (key === "support_email") {
              return `Error in Support Email: ${msg}`;
            }
            return msg;
          });
        }
        return messages;
      });

      // Join errors with line breaks
      return errors.join("<br/>") || "Invalid input. Please check your data.";
    }
    return "An unexpected error occurred. Please try again later.";
  };

  const onSubmit = async (item) => {
    setIsLoading2(true);

    const data = item;

    // console.log(data);

    try {
      let res;

      if (businessDetails) {
        res = await updateBusinessDetails(token, data, businessId);
      } else {
        res = await createBusinessDetails(token, data);
      }

      // console.log(res.data);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Updated!",
          text: `Business details for ${item.bussiness_name} have been updated successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          fetchBusinessDetails();
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        // console.log(res);
        const errorMessage = getErrorMessage(res);
        Swal.fire("Error", errorMessage, "error");
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during updating business details:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Business Details</h4>
                {/* <Link to="/business">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link> */}
              </div>
              <div className="card-body py-3">
                <div className="basic-form">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      {/* Business Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Business Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          {...register("bussiness_name", {
                            required: "Business name is required",
                          })}
                        />
                        {errors.bussiness_name && (
                          <p className="error">
                            {errors.bussiness_name.message}
                          </p>
                        )}
                      </div>

                      {/* Currency */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Currency</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          {...register("currency", {
                            required: "Currency is required",
                          })}
                        />
                        {errors.currency && (
                          <p className="error">{errors.currency.message}</p>
                        )}
                      </div>

                      {/* Phone */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Phone Number</label>
                          <i className="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          maxLength={15}
                          {...register("phone_no", {
                            required: "Phone number is required",
                            pattern: {
                              value: /^(?:\+?\d{1,3}[- ]?)?(?:\d{3}-\d{8}|\d{4}-\d{7}|\d{10})$/,
                              message:
                                "Phone number must match one of these formats: +XX-XXXXXXXXXX, XXX-XXXXXXXX, XXXX-XXXXXXX, or XXXXXXXXXX",
                            },
                          })}
                        />
                        {errors.phone_no && (
                          <p className="error">{errors.phone_no.message}</p>
                        )}
                      </div>

                      {/* Email */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Email</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>

                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter your email"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                              message: "Please enter a valid email address",
                            },
                          })}
                        />
                        {errors.email && (
                          <p className="error">{errors.email.message}</p>
                        )}
                      </div>

                      {/* City */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">City</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          {...register("city", {
                            required: "City is required",
                          })}
                        />
                        {errors.city && (
                          <p className="error">{errors.city.message}</p>
                        )}
                      </div>

                      {/* State */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">State</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          {...register("state", {
                            required: "State is required",
                          })}
                        />
                        {errors.state && (
                          <p className="error">{errors.state.message}</p>
                        )}
                      </div>

                      {/* Zip */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Zip Code</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          maxLength={6}
                          {...register("zip_code", {
                            required: "Zip code is required",
                            pattern: {
                              value: /^[0-9]{6}$/,
                              message: "Zip code is must be 6 digits",
                            },
                          })}
                        />
                        {errors.zip_code && (
                          <p className="error">{errors.zip_code.message}</p>
                        )}
                      </div>

                      {/* Country */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Country</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          {...register("country", {
                            required: "Country is required",
                          })}
                        />
                        {errors.country && (
                          <p className="error">{errors.country.message}</p>
                        )}
                      </div>

                      {/* Status */}
                      {/* <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Status</label>
                          <i className="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <Select
                          options={[
                            { value: "Active", label: "Active" },
                            { value: "Inactive", label: "Inactive" },
                          ]}
                          {...register("status", {
                            required: "Status is required",
                          })}
                          onChange={(selectedOption) => {
                            setValue("status", selectedOption?.value);
                            clearErrors("status");
                          }}
                          placeholder="Select Status"
                          isClearable
                          value={[
                            { value: "Active", label: "Active" },
                            { value: "Inactive", label: "Inactive" },
                          ].find((option) => option.value === watch("status"))}
                        />
                        {errors.status && (
                          <p className="error">{errors.status.message}</p>
                        )}
                      </div> */}

                      {/* GST Number */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">GST Number</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          {...register("gst_no", {
                            required: "GST number is required",
                          })}
                        />
                        {errors.gst_no && (
                          <p className="error">{errors.gst_no.message}</p>
                        )}
                      </div>

                      {/* Support Phone */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Support Phone</label>
                          <i className="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          maxLength={15}
                          {...register("support_phone_no", {
                            required: "Support phone is required",
                            pattern: {
                              value: /^(?:\+?\d{1,3}[- ]?)?(?:\d{3}-\d{8}|\d{4}-\d{7}|\d{10})$/,
                              message:
                                "Support phone number must match one of these formats: +XX-XXXXXXXXXX, XXX-XXXXXXXX, XXXX-XXXXXXX, or XXXXXXXXXX",
                            },
                          })}
                        />
                        {errors.support_phone_no && (
                          <p className="error">
                            {errors.support_phone_no.message}
                          </p>
                        )}
                      </div>

                      {/* Support Email */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Support Email</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>

                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter your support email"
                          {...register("support_email", {
                            required: "Suppoet email is required",
                            pattern: {
                              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                              message: "Please enter a valid email address",
                            },
                          })}
                        />
                        {errors.support_email && (
                          <p className="error">
                            {errors.support_email.message}
                          </p>
                        )}
                      </div>

                      {/* Address */}
                      <div className="mb-4 col-md-12">
                        <div className="d-flex">
                          <label className="form-label">Address</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <textarea
                          rows="3"
                          className="form-control"
                          {...register("address", {
                            required: "Address is required",
                          })}
                        ></textarea>
                        {errors.address && (
                          <p className="error">{errors.address.message}</p>
                        )}
                      </div>

                      {/* About */}
                      <div className="mb-4 col-md-12">
                        <div className="d-flex">
                          <label className="form-label">About</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <textarea
                          rows="3"
                          className="form-control"
                          {...register("about", {
                            required: "About is required",
                          })}
                        ></textarea>
                        {errors.about && (
                          <p className="error">{errors.about.message}</p>
                        )}
                      </div>
                    </div>

                    {!isLoading2 ? (
                      <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary w-100">
                          UPDATE BUSINESS DETAILS
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-4">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          UPDATING BUSINESS DETAILS
                        </button>
                        <div
                          className="spinner-border2 text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
